var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTigerAfraid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9255 45.8338C77.9255 45.8338 66.1192 22.4249 47.7992 21C47.7992 21 35.7895 22.832 30.7006 33.0098C23.9833 47.0551 28.2579 66.1893 33.1432 74.3315C38.0286 82.4738 53.7024 82.0667 53.7024 82.0667C53.7024 82.0667 61.2339 60.8969 77.9255 45.8338Z",
    fill: "url(#paint0_linear_83_5570)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4737 58.8609C63.4737 58.8609 50.4462 36.877 39.2506 36.877C28.0551 36.877 28.2586 54.9934 30.4977 64.3569C32.7369 73.5169 34.7724 81.6592 52.2782 82.2698C52.2782 82.0663 56.1457 70.6672 63.4737 58.8609Z",
    fill: "url(#paint1_radial_83_5570)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4723 58.8611C63.4723 58.8611 50.4448 56.622 38.2314 73.7207C38.2314 73.7207 44.7452 67.614 55.1266 67.0033C55.1266 67.0033 48.0021 68.6318 43.7274 75.9598C39.4528 83.2878 46.3737 98.1473 46.3737 98.1473C46.3737 98.1473 50.8519 84.102 63.4723 58.8611Z",
    fill: "url(#paint2_radial_83_5570)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.813 263.028C128.813 263.028 119.857 269.542 121.485 284.809C123.114 300.075 144.487 307.607 144.487 307.607L150.594 315.342L191.305 313.51L200.261 280.127L128.813 263.028Z",
    fill: "#932F31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0229 227.812C95.0229 227.812 89.5269 234.937 76.4994 241.043C63.2683 247.15 61.8434 247.761 60.0114 252.646C57.9758 257.531 58.79 275.241 62.454 282.772C66.118 290.304 77.11 292.543 81.7918 289.489C86.4736 286.436 89.1198 280.94 89.7305 276.258C90.1376 271.577 89.1198 264.249 89.1198 264.249C89.1198 264.249 105.404 269.745 113.139 263.231C120.874 256.717 121.689 239.822 121.689 239.822C121.689 239.822 99.7047 227.609 95.0229 227.812Z",
    fill: "#932F31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.272 288.268L197.006 295.799L179.093 304.756C179.093 304.756 174.208 302.924 166.676 299.667C165.862 299.26 165.048 299.056 164.233 298.649C157.312 295.392 148.56 291.118 139.807 285.622C130.443 279.922 120.876 273.001 113.548 265.063C111.716 263.027 110.088 261.195 108.459 259.159C91.3605 236.972 94.6174 215.395 94.6174 215.395L83.2183 217.431C90.1391 213.97 95.8387 208.474 100.317 203.385C106.424 196.261 109.68 189.747 109.68 189.747C115.787 184.251 147.745 180.994 147.745 180.994C147.745 180.994 148.56 183.233 150.799 187.101C152.631 190.561 155.48 195.039 159.348 200.535C160.366 201.96 162.198 203.996 164.233 206.235C177.668 220.891 207.387 247.353 207.387 247.353L212.272 288.268Z",
    fill: "url(#paint3_radial_83_5570)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.005 295.8L179.092 304.757C179.092 304.757 174.206 302.925 166.675 299.668C165.861 299.261 165.046 299.057 164.232 298.65C157.311 295.393 148.558 291.118 139.806 285.622C130.442 279.923 120.875 273.002 113.547 265.063C111.715 263.028 110.086 261.196 108.458 259.16C109.476 260.381 126.371 278.498 148.558 280.737C171.56 283.18 178.888 267.709 178.888 267.709L197.005 295.8Z",
    fill: "url(#paint4_linear_83_5570)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.228 309.031C221.635 311.474 221.838 314.324 220.413 315.545C217.767 317.988 169.525 316.766 169.525 316.766C169.525 316.766 165.861 306.181 166.471 299.668C166.471 299.464 166.471 299.464 166.471 299.26C166.675 298.243 166.878 297.225 167.285 296.614C170.339 291.118 185.605 293.357 185.605 293.357C185.605 293.357 174.41 272.188 178.481 260.788C182.552 249.593 190.084 249.593 190.084 249.593C190.084 249.593 181.534 235.548 169.932 234.53C169.932 234.53 170.135 235.751 170.542 237.99C171.967 245.522 174.817 264.249 173.189 275.852C172.374 282.365 168.1 290.915 163.825 298.446C157.922 308.42 151.815 316.97 151.815 316.97L128.814 316.156C128.814 316.156 125.557 309.642 124.946 304.756C124.742 303.128 124.742 301.703 125.353 300.889C127.592 297.021 133.495 298.039 136.345 295.393C137.363 294.375 138.788 290.915 139.806 285.622C141.434 277.276 142.045 263.842 139.398 246.743C138.177 238.397 137.363 231.069 136.956 224.352C136.142 208.882 138.177 198.297 142.248 193.412C145.302 189.951 147.948 187.916 150.594 186.898C153.24 185.88 155.479 185.88 157.311 187.101C157.311 187.101 160.772 194.226 167.489 203.182C172.782 210.307 180.313 218.652 189.473 225.573C210.236 241.044 223.06 245.115 230.184 255.903C237.309 266.692 230.388 295.393 220.006 304.553C220.21 304.553 221.024 306.588 221.228 309.031Z",
    fill: "url(#paint5_radial_83_5570)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.681 189.543C109.681 189.543 114.77 202.774 128.815 203.181C142.86 203.589 158.738 189.543 158.738 189.543L157.516 187.101L109.681 189.543Z",
    fill: "url(#paint6_radial_83_5570)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.693 203.182C167.693 203.182 166.472 204.2 164.233 206.032C158.94 210.307 147.948 218.449 137.16 224.352C128.407 229.034 119.654 232.291 113.751 230.866C97.263 226.795 100.316 203.182 100.316 203.182C106.423 196.058 109.68 189.544 109.68 189.544C115.787 184.048 147.745 180.791 147.745 180.791C147.745 180.791 148.559 183.03 150.798 186.898C153.444 185.88 155.683 185.88 157.515 187.101C157.515 187.101 160.976 194.226 167.693 203.182Z",
    fill: "#CE777C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.907 45.8338C179.907 45.8338 191.713 22.4249 210.033 21C210.033 21 222.043 22.832 227.132 33.0098C233.849 47.0551 229.575 66.1893 224.689 74.3315C219.804 82.4738 204.13 82.0667 204.13 82.0667C204.13 82.0667 196.599 60.8969 179.907 45.8338Z",
    fill: "url(#paint7_linear_83_5570)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.362 144.15L229.574 141.707C229.574 141.707 227.335 144.964 223.06 149.849C212.068 162.266 187.845 184.454 153.648 187.507C153.648 187.507 145.098 197.074 132.885 200.128L133.699 198.092C133.699 198.092 124.336 195.446 115.99 189.746C115.176 189.746 55.1269 189.543 28.8683 152.903L17.2656 153.921C17.2656 153.921 19.0976 151.885 22.151 147.814C28.8683 138.857 41.0816 120.13 47.1883 95.5001C55.9412 60.4885 75.6861 45.629 75.6861 45.629C75.6861 45.629 104.998 25.2734 140.213 25.2734L132.682 28.9374C132.682 28.9374 174.818 36.0619 192.12 56.0103C209.422 75.9588 210.033 118.705 240.362 144.15Z",
    fill: "url(#paint8_radial_83_5570)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.574 141.708C229.574 141.708 201.077 183.233 153.648 187.508C153.648 187.508 145.099 197.075 132.886 200.128L133.7 198.093C133.7 198.093 124.336 195.447 115.99 189.747C115.176 189.747 55.1273 189.544 28.8687 152.904C62.6589 176.312 104.388 150.868 104.388 150.868C131.868 155.143 152.02 150.461 152.02 150.461C201.687 169.188 229.574 141.708 229.574 141.708Z",
    fill: "url(#paint9_radial_83_5570)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.202 150.461L107.238 155.957C107.238 155.957 121.079 156.568 126.168 162.064H130.443H134.718C139.807 156.364 153.648 155.957 153.648 155.957L155.887 149.851C137.16 151.886 124.133 152.497 105.202 150.461Z",
    fill: "url(#paint10_radial_83_5570)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.648 144.559C143.878 140.895 143.878 98.7593 151.002 77.793C158.127 56.8268 197.616 76.7753 206.776 102.627C215.733 128.478 210.033 136.01 204.334 139.063C198.227 142.117 171.154 151.073 153.648 144.559Z",
    fill: "url(#paint11_radial_83_5570)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.359 58.8609C194.359 58.8609 207.386 36.877 218.582 36.877C229.778 36.877 229.574 54.9934 227.335 64.3569C225.096 73.5169 223.06 81.6592 205.554 82.2698C205.554 82.0663 201.687 70.6672 194.359 58.8609Z",
    fill: "url(#paint12_radial_83_5570)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.359 58.8611C194.359 58.8611 207.386 56.622 219.6 73.7207C219.6 73.7207 213.086 67.614 202.705 67.0033C202.705 67.0033 209.829 68.6318 214.104 75.9598C218.378 83.2878 211.458 98.1473 211.458 98.1473C211.458 98.1473 206.979 84.102 194.359 58.8611Z",
    fill: "url(#paint13_radial_83_5570)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.338 93.8728C147.338 93.8728 150.392 71.8888 164.641 71.4817C179.093 71.0746 205.148 91.8372 210.644 118.299C210.644 118.299 211.865 103.44 196.395 86.5448C180.925 69.6497 165.658 62.7288 157.109 66.5964C148.763 70.2604 147.338 93.8728 147.338 93.8728Z",
    fill: "#9D3D3A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.205 125.832C151.205 125.832 147.541 96.9271 168.1 90.8204C188.659 84.7138 204.333 106.291 200.669 126.646L151.205 125.832Z",
    fill: "#75272C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.24 136.01C156.904 148.427 180.72 148.834 194.358 138.656C207.996 128.275 198.226 97.9448 178.684 94.2808C158.939 90.8203 145.505 110.362 153.24 136.01Z",
    fill: "url(#paint14_linear_83_5570)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.119 139.267C177.775 139.267 184.792 132.068 184.792 123.186C184.792 114.305 177.775 107.105 169.119 107.105C160.462 107.105 153.445 114.305 153.445 123.186C153.445 132.068 160.462 139.267 169.119 139.267Z",
    fill: "url(#paint15_radial_83_5570)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.119 133.974C174.964 133.974 179.703 129.144 179.703 123.186C179.703 117.228 174.964 112.397 169.119 112.397C163.273 112.397 158.534 117.228 158.534 123.186C158.534 129.144 163.273 133.974 169.119 133.974Z",
    fill: "#75272C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.81 116.468C185.81 117.893 184.589 119.115 183.164 119.115C181.739 119.115 180.518 117.893 180.518 116.468C180.518 115.044 181.739 113.822 183.164 113.822C184.792 113.822 185.81 115.044 185.81 116.468Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.81 139.267L175.632 127.461L165.454 129.496L163.215 143.135C163.215 143.135 179.703 148.02 185.81 139.267Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.445 136.823C153.445 136.823 155.073 148.222 176.447 146.39C197.82 144.558 199.855 130.31 199.855 130.31C199.855 130.31 198.431 142.116 175.225 145.373C159.144 147.612 153.445 136.823 153.445 136.823Z",
    fill: "#BD4C3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.016 144.559C115.787 140.895 115.787 98.7593 108.662 77.793C101.334 56.8268 62.0481 76.7753 52.8881 102.627C43.9317 128.478 49.6312 136.01 55.3308 139.063C61.2339 142.117 88.3068 151.073 106.016 144.559Z",
    fill: "url(#paint16_radial_83_5570)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.326 93.8728C112.326 93.8728 109.273 71.8888 95.0238 71.4817C80.5714 71.0746 54.5163 91.8372 49.0203 118.299C49.0203 118.299 47.7989 103.44 63.2692 86.5448C78.7394 69.6497 94.006 62.7288 102.555 66.5964C110.901 70.2604 112.326 93.8728 112.326 93.8728Z",
    fill: "#9D3D3A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.46 125.832C108.46 125.832 112.124 96.9271 91.5645 90.8204C71.0054 84.7138 55.3316 106.291 58.9956 126.646L108.46 125.832Z",
    fill: "#75272C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.424 136.01C102.76 148.427 78.9437 148.834 65.3055 138.656C51.6673 128.275 61.438 97.9448 80.9793 94.2808C100.724 90.8203 113.955 110.362 106.424 136.01Z",
    fill: "url(#paint17_linear_83_5570)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5473 139.267C99.2037 139.267 106.221 132.068 106.221 123.186C106.221 114.305 99.2037 107.105 90.5473 107.105C81.8909 107.105 74.8735 114.305 74.8735 123.186C74.8735 132.068 81.8909 139.267 90.5473 139.267Z",
    fill: "url(#paint18_radial_83_5570)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9624 123.186C79.9624 129.089 84.6442 133.974 90.5473 133.974C96.4504 133.974 101.132 129.089 101.132 123.186C101.132 117.283 96.4504 112.397 90.5473 112.397C84.6442 112.397 79.9624 117.079 79.9624 123.186Z",
    fill: "#75272C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6509 116.468C73.6509 117.893 74.8722 119.115 76.2971 119.115C77.722 119.115 78.9433 117.893 78.9433 116.468C78.9433 115.044 77.722 113.822 76.2971 113.822C74.8722 113.822 73.6509 115.044 73.6509 116.468Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6509 139.267L83.8287 127.461L94.0064 129.496L96.4491 143.338C96.4491 143.135 79.9611 148.02 73.6509 139.267Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.22 136.823C106.22 136.823 104.592 148.222 83.2185 146.39C61.8451 144.558 59.8096 130.31 59.8096 130.31C59.8096 130.31 61.2345 142.116 84.4398 145.373C100.521 147.612 106.22 136.823 106.22 136.823Z",
    fill: "#BD4C3A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.779 180.791C128.204 183.437 149.17 181.809 151.002 178.348C152.631 174.888 137.975 166.135 133.089 167.763C128.204 169.392 125.761 178.959 126.779 180.791Z",
    fill: "url(#paint19_radial_83_5570)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.796 179.977C129.017 182.216 147.745 179.977 148.559 177.534C149.577 174.888 140.417 167.356 133.903 168.781C127.389 170.206 126.575 177.941 127.796 179.977Z",
    fill: "url(#paint20_linear_83_5570)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.593 179.569C127.593 179.569 128.407 177.737 129.425 177.737C130.443 177.737 130.647 180.994 130.647 180.994C130.647 180.994 127.797 180.994 127.593 179.569Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.692 179.366C144.692 179.366 144.082 176.516 145.303 175.702C146.524 175.092 148.56 177.331 148.56 177.331C148.56 177.331 147.949 178.756 144.692 179.366Z",
    fill: "#F5F5F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.202 150.461L112.327 140.487C112.327 140.487 127.797 132.955 146.524 139.266L156.091 150.054C156.091 149.85 128.204 154.736 105.202 150.461Z",
    fill: "#FF9F30"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.202 150.461C105.202 150.461 132.275 152.904 155.887 149.851C156.091 149.851 126.168 155.55 105.202 150.461Z",
    fill: "#75272C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.151 148.02C24.3901 149.241 26.8327 150.869 29.2754 153.108L17.2656 153.923C17.2656 153.923 19.0976 151.887 22.151 148.02Z",
    fill: "url(#paint21_linear_83_5570)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.061 149.851C212.069 162.267 187.846 184.455 153.648 187.508C153.648 187.508 145.099 197.075 132.886 200.129L133.7 198.093C133.7 198.093 124.336 195.447 115.99 189.747C115.176 189.747 55.1273 189.544 28.8687 152.904C69.9869 187.712 116.805 183.03 116.805 183.03C116.805 183.03 121.486 191.376 133.7 192.19C146.117 193.004 152.834 181.809 152.834 181.809C192.731 180.791 223.061 149.851 223.061 149.851Z",
    fill: "url(#paint22_linear_83_5570)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.38 28.5319C115.38 28.5319 128.204 47.0554 127.797 92.0412C127.797 92.0412 131.054 62.7292 139.603 30.5674L132.682 29.1426L140.214 25.4786C140.214 25.275 125.761 25.275 115.38 28.5319Z",
    fill: "#9D3D3A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.001 33.416C151.001 33.416 141.026 55.8071 139.602 78.4018C139.602 78.4018 152.629 48.2756 174.613 42.7796C174.613 42.9831 161.178 35.4516 151.001 33.416Z",
    fill: "#9D3D3A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1382 37.6903C90.1382 37.6903 108.051 45.629 115.583 69.0379C115.583 69.0379 115.176 47.6645 108.662 30.3623C108.662 30.3623 98.2804 33.4156 90.1382 37.6903Z",
    fill: "#9D3D3A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.096 126.646C225.096 126.646 224.282 136.824 208.811 145.984C193.341 155.144 168.915 155.958 168.915 155.958C168.915 155.958 212.068 164.101 229.574 141.71L240.363 144.152L225.096 126.646Z",
    fill: "#9D3D3A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.289 103.032C213.289 103.032 221.432 129.291 202.501 141.911C202.501 141.911 221.228 136.619 222.449 122.574C222.449 122.37 215.121 107.714 213.289 103.032Z",
    fill: "#9D3D3A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3465 130.31C33.3465 130.31 31.9216 146.187 48.8167 153.922C65.7118 161.657 90.1385 157.586 90.1385 157.586C90.1385 157.586 56.1447 172.242 29.2754 152.904L17.2656 153.922L33.3465 130.31Z",
    fill: "#9D3D3A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8967 112.397C41.8967 112.397 39.4541 128.885 46.3749 136.824C53.2958 144.559 70.1909 147.205 70.1909 147.205C70.1909 147.205 54.3136 150.259 43.1181 144.763C31.9225 139.267 35.1794 127.664 35.1794 127.664C35.1794 127.664 40.4718 115.858 41.8967 112.397Z",
    fill: "#9D3D3A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.566 231.069C137.566 231.069 145.912 223.334 163.214 231.069C163.214 231.069 152.425 232.901 138.584 240.025L137.566 231.069Z",
    fill: "#9D3D3A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.62 255.497C140.62 255.497 152.629 245.115 170.542 255.497C170.542 255.497 148.762 254.479 141.23 263.028L140.62 255.497Z",
    fill: "#9D3D3A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.231 268.525C141.231 268.525 158.737 265.471 173.19 278.295C173.19 278.295 151.409 272.596 140.824 278.295L141.231 268.525Z",
    fill: "#9D3D3A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.417 280.941C140.417 280.941 157.719 277.481 167.693 292.137L162.197 301.907C162.197 301.907 156.701 293.765 139.399 287.048L140.417 280.941Z",
    fill: "#9D3D3A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.164 220.281C183.164 220.281 191.102 232.495 189.474 245.522C189.474 245.522 193.545 239.619 192.527 227.813C192.527 227.813 185.81 222.724 183.164 220.281Z",
    fill: "#9D3D3A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.836 232.088C198.836 232.088 200.872 241.248 194.562 250.001C194.562 250.001 204.129 245.93 205.961 236.77L198.836 232.088Z",
    fill: "#9D3D3A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.812 259.16C231.812 259.16 227.538 265.674 208.607 266.692C189.676 267.506 183.366 271.577 183.366 271.577C183.366 271.577 190.084 269.338 209.014 271.577C227.945 273.816 233.237 269.949 233.237 269.949C233.237 269.949 233.441 262.213 231.812 259.16Z",
    fill: "#9D3D3A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.831 273.409C232.831 273.409 227.131 280.534 207.183 283.994C207.183 283.994 224.485 287.047 231.609 282.162C231.406 282.162 232.22 279.109 232.831 273.409Z",
    fill: "#9D3D3A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.597 275.853C172.783 282.366 168.508 290.916 164.233 298.447C158.33 308.422 152.224 316.971 152.224 316.971L128.815 316.157C128.815 316.157 125.558 309.643 124.947 304.757C124.947 304.757 141.232 314.528 160.773 296.819C180.111 279.11 170.544 236.566 170.544 236.566L171.154 237.991C172.376 245.523 175.225 264.25 173.597 275.853Z",
    fill: "url(#paint23_linear_83_5570)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.415 315.545C217.768 317.988 169.526 316.767 169.526 316.767C169.526 316.767 165.862 306.182 166.472 299.668C166.472 299.464 166.472 299.464 166.472 299.261C168.101 301.296 173.393 304.96 189.678 307.403C212.883 311.067 221.025 308.828 221.025 308.828C221.84 311.474 221.84 314.324 220.415 315.545Z",
    fill: "url(#paint24_linear_83_5570)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.809 293.357L200.262 296.613C200.262 296.613 178.074 276.665 178.278 262.823C178.278 263.027 176.039 274.833 185.809 293.357Z",
    fill: "url(#paint25_linear_83_5570)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.676 299.668C166.676 299.668 174.004 305.571 189.882 307.607C205.759 309.439 212.273 307.2 212.273 307.2C212.273 307.2 199.856 296.004 185.81 293.358C171.765 290.712 166.676 296.004 166.676 299.668Z",
    fill: "#FF9F30"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.189 316.766C173.189 316.766 169.118 300.888 173.189 297.428C173.189 297.428 172.375 308.216 174.207 316.766H173.189Z",
    fill: "#BD4C3A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.313 316.766C180.313 316.766 180.313 306.792 181.331 304.349C182.349 301.906 184.588 300.889 184.588 300.889C184.588 300.889 180.924 304.96 181.127 316.766H180.313Z",
    fill: "#BD4C3A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.353 300.889C125.353 300.889 128.203 304.146 140.823 304.146C153.444 304.146 154.869 300.686 154.869 300.686L136.345 295.597C136.345 295.393 125.76 297.836 125.353 300.889Z",
    fill: "#FF9F30"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.239 316.359C130.239 316.359 126.575 306.385 127.593 303.331C128.61 300.278 132.274 299.464 132.274 299.464C132.274 299.464 129.832 300.278 129.018 304.96C128.203 309.438 130.239 316.359 130.239 316.359Z",
    fill: "#BD4C3A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.345 316.561C136.345 316.561 134.92 306.994 136.752 303.737C138.584 300.481 143.673 300.684 143.673 300.684C143.673 300.684 139.602 300.481 137.77 304.959C135.734 309.233 136.345 316.561 136.345 316.561Z",
    fill: "#BD4C3A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.163 256.92C178.278 260.991 190.695 277.072 210.847 276.869C230.795 276.665 227.945 262.62 226.113 259.159C224.485 255.699 198.226 244.3 183.163 256.92Z",
    fill: "#FFC763"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2187 49.7016C80.9796 57.0296 117.009 64.7647 141.639 63.1363C166.269 61.5078 176.244 51.9407 177.668 49.7016C179.093 47.2589 163.623 35.0456 130.444 31.5852C97.264 28.1247 84.2365 46.6483 83.2187 49.7016Z",
    fill: "#FFC763"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.633 313.713C297.969 318.598 264.789 320.226 247.08 317.784C229.371 315.341 230.999 297.225 230.999 297.225L229.574 295.189L227.946 292.746L233.238 271.373C233.238 271.373 239.345 281.347 258.072 287.047C273.135 291.525 284.534 290.711 291.659 291.525C291.862 291.525 292.269 291.525 292.473 291.525C293.694 291.729 294.916 291.932 295.933 292.339C302.244 294.985 305.297 308.827 301.633 313.713Z",
    fill: "url(#paint26_radial_83_5570)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.303 292.949C271.303 292.949 287.587 291.117 294.712 303.941C294.712 303.941 294.101 297.224 286.366 291.932L271.303 292.949Z",
    fill: "#9D3D3A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.232 289.286C267.232 289.286 265.197 290.711 265.604 292.136L271.303 292.95C271.303 292.95 273.746 291.525 276.392 290.507L267.232 289.286Z",
    fill: "#9D3D3A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.744 284.401L249.727 288.676L256.647 290.304L257.869 287.048C258.072 287.048 252.576 285.216 250.744 284.401Z",
    fill: "#9D3D3A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.659 291.525C289.623 291.321 286.57 291.932 286.57 291.932C286.57 291.932 280.667 293.764 271.303 292.95C262.143 292.339 244.434 287.861 236.902 288.675C230.796 289.489 229.778 293.561 229.574 295.189L227.946 292.746L233.238 271.373C233.238 271.373 239.345 281.347 258.072 287.047C273.135 291.525 284.534 290.711 291.659 291.525Z",
    fill: "#CE777C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.303 292.951C271.303 292.951 283.11 303.943 281.074 318.395C281.074 318.395 259.904 320.634 244.23 317.174C228.557 313.713 226.521 294.375 233.238 289.083C239.956 283.994 262.143 292.747 271.303 292.951Z",
    fill: "url(#paint27_linear_83_5570)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.238 292.951C230.999 299.668 250.336 307.403 271.303 307.2C292.269 306.996 295.729 293.561 293.897 292.951C292.065 292.34 288.198 294.783 271.303 293.968C254.204 292.951 236.291 283.384 233.238 292.951Z",
    fill: "#FFC763"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.525 316.767C169.525 316.767 210.847 316.767 219.803 315.953C220.007 315.953 217.768 318.396 169.525 316.767Z",
    fill: "#9D3D3A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.813 316.157C128.813 316.157 147.744 315.342 152.019 316.971C152.222 317.174 136.345 317.378 128.813 316.157Z",
    fill: "#9D3D3A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.371 162.064C126.371 162.064 120.672 152.701 107.44 155.958C107.44 155.958 118.432 154.126 126.371 162.064Z",
    fill: "#75272C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.718 162.065C134.718 162.065 142.249 153.109 153.648 155.958C153.648 155.958 143.878 154.533 134.718 162.065Z",
    fill: "#75272C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0289 250.001C61.0289 250.001 60.6218 248.779 75.6849 245.726C90.748 242.469 94.412 228.424 94.412 228.424C94.412 228.424 87.4911 235.752 75.2778 240.637C63.0645 245.319 61.0289 250.001 61.0289 250.001Z",
    fill: "url(#paint28_radial_83_5570)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.046 224.353C165.046 224.353 172.374 245.319 174.002 263.842C174.002 264.046 172.781 233.92 165.046 224.353Z",
    fill: "#BD4C3A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.23 317.174C244.23 317.174 248.505 319.006 274.153 318.192C299.801 317.378 302.65 311.882 302.65 311.882C302.65 311.882 302.65 313.307 301.226 314.935C299.597 316.564 268.25 323.485 244.23 317.174Z",
    fill: "#BD4C3A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.518 256.921C180.518 256.921 182.96 251.018 195.784 250.001C208.608 248.983 217.565 253.461 217.565 253.461C217.565 253.461 203.926 246.947 189.881 249.186C190.085 249.186 182.96 250.815 180.518 256.921Z",
    fill: "#9D3D3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_5570",
    x1: 52.6705,
    y1: 82.0827,
    x2: 52.6705,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3364 59.4399) rotate(180) scale(20.0907 20.0907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8275 78.5073) rotate(180) scale(16.5721 16.5721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.755 242.756) scale(63.2663 63.2663)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83_5570",
    x1: 108.541,
    y1: 281.97,
    x2: 196.99,
    y2: 281.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#E08893"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.474 219.362) scale(64.645 64.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.249 195.129) scale(18.2314 18.2315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_83_5570",
    x1: 205.124,
    y1: 82.0827,
    x2: 205.124,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.89 69.6435) scale(98.851 98.851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.436 170.998) scale(73.8035 73.8035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.633 155.975) scale(18.3375 20.9811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.571 108.007) scale(35.9695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFEC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.458 59.4399) scale(20.0907 20.0907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.965 78.5073) scale(16.5721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_83_5570",
    x1: 175.807,
    y1: 145.943,
    x2: 175.807,
    y2: 93.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.192 131.95) scale(15.6071 16.0173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.005 108.007) rotate(180) scale(35.9695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFEC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_83_5570",
    x1: 83.7676,
    y1: 145.943,
    x2: 83.7676,
    y2: 93.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.3857 131.95) rotate(180) scale(15.6071 16.0173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.842 174.797) scale(10.0978 10.0978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_83_5570",
    x1: 137.978,
    y1: 180.987,
    x2: 137.978,
    y2: 168.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#C9311F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#971E53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_83_5570",
    x1: 23.254,
    y1: 153.955,
    x2: 23.254,
    y2: 147.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_83_5570",
    x1: 126.163,
    y1: 200.243,
    x2: 126.163,
    y2: 149.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_83_5570",
    x1: 149.507,
    y1: 317.092,
    x2: 149.507,
    y2: 236.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_83_5570",
    x1: 194.055,
    y1: 317.099,
    x2: 194.055,
    y2: 299.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_83_5570",
    x1: 189.152,
    y1: 296.671,
    x2: 189.152,
    y2: 262.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265.581 295.183) scale(31.4579 31.4579)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_83_5570",
    x1: 255.472,
    y1: 319.151,
    x2: 255.472,
    y2: 287.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FFC772"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_83_5570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1778 233.932) scale(13.3264 13.3264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigerAfraid);
export default __webpack_public_path__ + "static/media/tiger_afraid.646d0e4b50bcb0307d8e169b74dfc329.svg";
export { ForwardRef as ReactComponent };